import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useT } from "@/i18n";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PrivacyPolicy() {
  const { t, lang } = useT();

  useEffect(() => {
    document.title = "Privacy Policy — Makario";
    window.scrollTo(0, 0);
  }, []);

  const sections = lang === "id" ? [
    {
      h: "1. Data yang Kami Kumpulkan",
      p: "Kami mengumpulkan data yang Anda berikan secara sukarela melalui formulir kontak (nama, email, subjek, dan pesan) serta data analitik anonim seperti halaman yang dikunjungi, durasi kunjungan, dan rujukan.",
    },
    {
      h: "2. Bagaimana Kami Menggunakannya",
      p: "Data digunakan untuk menanggapi permintaan Anda, meningkatkan kualitas situs, dan, dengan persetujuan, mengirim komunikasi pemasaran yang relevan. Kami tidak menjual data Anda kepada pihak ketiga.",
    },
    {
      h: "3. Cookies",
      p: "Kami menggunakan cookies untuk preferensi bahasa dan analitik anonim. Anda dapat menonaktifkan cookies melalui pengaturan browser kapan saja. Banner persetujuan akan muncul saat kunjungan pertama.",
    },
    {
      h: "4. Penyimpanan & Keamanan",
      p: "Data disimpan di server tepercaya dengan enkripsi at-rest dan in-transit. Akses dibatasi pada personel yang membutuhkan untuk tujuan operasional.",
    },
    {
      h: "5. Hak Anda",
      p: "Anda berhak meminta akses, koreksi, atau penghapusan data pribadi Anda. Hubungi kami di hello@makario.id untuk menjalankan hak ini sesuai UU Perlindungan Data Pribadi Indonesia.",
    },
    {
      h: "6. Kontak",
      p: "Pertanyaan terkait privasi dapat dikirim ke hello@makario.id. Kami akan merespons dalam 14 hari kerja.",
    },
  ] : [
    {
      h: "1. Data We Collect",
      p: "We collect data you voluntarily provide via the contact form (name, email, subject, message) and anonymous analytics such as pages visited, visit duration, and referrers.",
    },
    {
      h: "2. How We Use It",
      p: "Data is used to respond to your inquiry, improve the site, and — with consent — send relevant marketing communications. We do not sell your data to third parties.",
    },
    {
      h: "3. Cookies",
      p: "We use cookies for language preference and anonymous analytics. You can disable cookies through your browser settings at any time. A consent banner appears on first visit.",
    },
    {
      h: "4. Storage & Security",
      p: "Data is stored on trusted servers with at-rest and in-transit encryption. Access is restricted to personnel who require it for operational purposes.",
    },
    {
      h: "5. Your Rights",
      p: "You may request access, correction, or deletion of your personal data. Reach us at hello@makario.id to exercise these rights under Indonesia's Personal Data Protection Law.",
    },
    {
      h: "6. Contact",
      p: "Privacy-related questions can be sent to hello@makario.id. We aim to respond within 14 working days.",
    },
  ];

  return (
    <main data-testid="privacy-policy" className="normal-scroll">
      <Navbar />

      <section className="pt-40 pb-16 px-8 md:px-24 lg:px-40" style={{ background: "var(--ink)" }}>
        <div className="max-w-[720px] mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-white/70 hover:text-white text-[0.7rem] font-mono uppercase tracking-[0.22em] mb-14">
            <ArrowLeft size={14} /> {t("detail.back")}
          </Link>
          <h1 className="h-hero text-white">
            {lang === "id" ? "Kebijakan Privasi" : "Privacy Policy"}
          </h1>
          <p className="mt-6 text-white/60 body-text">
            {lang === "id"
              ? "Terakhir diperbarui: Desember 2025"
              : "Last updated: December 2025"}
          </p>
        </div>
      </section>

      <section className="py-24 md:py-32 px-8 md:px-24 lg:px-40" style={{ background: "var(--paper)" }}>
        <div className="max-w-[720px] mx-auto space-y-12">
          {sections.map((s) => (
            <div key={s.h}>
              <h2 className="h-sub text-[var(--ink)] mb-4">{s.h}</h2>
              <p className="text-black/70 body-text">{s.p}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </main>
  );
}
